<template>
  <LayoutHeader main="history" ref="layout" :loadingOverlay="loadingOverlay" :me="me" :lastApp="lastApp" :appHistory="appHistory">
    <article v-if="me && histories !== null">
      <div class="mt-4 mb-4 text-center">
        <router-link class="text-decoration-underline" :to="{ name: 'Account' }">戻る</router-link>
      </div>
      <h1 class="text-center mb-4">ご利用履歴</h1>
      <div class="text-center mb-4">
        ウォレット残高：<strong>{{ me.total.toLocaleString() }}</strong> 円
      </div>
      <div v-for="history in histories" v-if="histories.length > 0" class="histories">
        <div class="history purchase" v-if="history.Purchase">
          <h2>ご利用</h2>
          <div>
            {{ history.Purchase.App.name }}<br />
            {{ history.Purchase.name }}<br />
            - {{ history.Purchase.amount.toLocaleString() }}円 <br />
            <div class="total">
              残高：{{ history.total.toLocaleString() }}円
            </div>
          </div>
          <div class="dateAt">{{ new Date(history.createdAt).toLocaleString() }}</div>
        </div>
        <div class="history order" v-else-if="history.Order">
          <div>
            <h2>ウォレット入金</h2>
            {{ history.Order.typeName }}<br />
            + {{ history.Order.amount.toLocaleString() }}円 <br />
            <div class="total">
              残高：{{ history.total.toLocaleString() }}円
            </div>
          </div>
          <div class="dateAt">{{ new Date(history.createdAt).toLocaleString() }}</div>
        </div>
        <div class="history order" v-else-if="history.CollectOrder">
          <div>
            <h2>ウォレット入金の取り消し</h2>
            {{ history.CollectOrder.typeName }}<br />
            - {{ history.CollectOrder.amount.toLocaleString() }}円 <br />
            <div class="total">
              残高：{{ history.total.toLocaleString() }}円
            </div>
          </div>
          <div class="dateAt">{{ new Date(history.createdAt).toLocaleString() }}</div>
        </div>
        <div class="history order" v-else>
          <div>
            <h2>返金</h2>
            + {{ history.amount.toLocaleString() }}円 <br />
            <div class="total">
              残高：{{ history.total.toLocaleString() }}円
            </div>
          </div>
          <div class="dateAt">{{ new Date(history.createdAt).toLocaleString() }}</div>
        </div>
      </div>
      <div v-else>
        <div class="text-center">履歴がありません</div>
      </div>
      <div class="mt-4 pb-4 text-center">
        <router-link class="text-decoration-underline" :to="{ name: 'Account' }">戻る</router-link>
      </div>
    </article>
  </LayoutHeader>
</template>

<script>
import baseMixin from './base'

export default {
  mixins: [
    baseMixin,
  ],
  data () {
    return {
      titlePrefix: 'ご利用履歴',
      histories: null,
    }
  },
  methods: {
    _mounted() {
      this.load();
    },
    async load() {
      this.histories = (await this.axios({
        url: '/histories',
        method: 'get',
      })).data.histories;
    },
  }
}
</script>
